export const isProd = true; // Set to true for production environment
export const pinCodeApi = "https://api.postalpincode.in/pincode/";
export const preProdToken = "c251eae6f77a1f043cff009a256914cee7aee6cd";
export const BASE_URL = isProd ? "https://prod.rashailagro.in" : "http://127.0.0.1:8000";
export const Pre_Prod_BASE_URL = isProd ? "https://preprod.dashboard.rashailagro.in" : "https://preprod.dashboard.rashailagro.in";
export const loginApiUrl = `${BASE_URL}/dashboard/staff-admin-login/`;
export const shopVisitorsUrl = `${BASE_URL}/dashboard/unique-shop-visitors`;
export const dukaanVisitorsUrl = `${BASE_URL}/dashboard/unique-dukaan-visitors`;
export const shopVisitorsCRUDUrl = `${BASE_URL}/bazzar/shop-visitor`;
export const dukaanVisitorsCRUDUrl = `${BASE_URL}/bazzar/dukaan-visitor`;
export const getWhatsappChatsUrl = `${Pre_Prod_BASE_URL}/whatsappwebhook/list-chat`;
export const getWhatsappChatsBetweenUsersUrl = `${Pre_Prod_BASE_URL}/whatsappwebhook/chat/`;
// Example: `${BASE_URL}/whatsappwebhook/chat/<phone>/`;
export const sendWhatsappMessagesUrl = `${Pre_Prod_BASE_URL}/whatsappwebhook/send-whatsapp-message/`;
export const sendWhatsappTemplateMessagesUrl = `${Pre_Prod_BASE_URL}/whatsappwebhook/send-whatsapp-template-message/`;
export const exportWhatsappMessagesUrl = `${Pre_Prod_BASE_URL}/whatsappwebhook/export-whatsapp-messages/`;
export const whatsappBulkChatHistoryUrl = `${Pre_Prod_BASE_URL}/whatsappwebhook/chat-history/bulk/`;
export const whatsappMonitorContactsUrl = `${BASE_URL}/dashboard/whatsapp-monitor/contacts`;
export const shopOrdersUrl = `${BASE_URL}/dashboard/shop-order-bazzar`;
export const trackUserOrdersUrl = `${BASE_URL}/dashboard/track-user-orders`;
export const manageOrdersUrl = `${BASE_URL}/dashboard/order-managment`;
export const orderSummaryUrl = `${BASE_URL}/dashboard/orders-summary`;
export const userSearchApiUrl = `${BASE_URL}/dashboard/user-search/`;
export const productSearchApiUrl = `${BASE_URL}/bazzar/products-list?search=`;
export const productSearchWithAkaNameApiUrl = `${BASE_URL}/dashboard/shop-product-search?search=`;
export const productDetailedApiUrl = `${BASE_URL}/bazzar/product-details/`;
// Ex: `${BASE_URL}/bazzar/product-details/<slug>/`;
export const productCRUDApiUrl = `${BASE_URL}/bazzar/shop-products/`;
/** Shop product dimensions — list + create/update/delete (dashboard) */
export const shopProductDimensionsListUrl = `${BASE_URL}/dashboard/shop-product-dimensions/`;
export const shopProductsDimensionCRUDUrl = `${BASE_URL}/bazzar/shop-product-dimension/`;
/** POST JSON (or multipart) — dashboard product create */
export const shopProductCreateApiUrl = `${BASE_URL}/dashboard/shop-product-create/`;
export const patchProductEditApiUrl = `${BASE_URL}/bazzar/shop-products-edit/`;
export const shopOrderOfflineUrl = `${BASE_URL}/dashboard/shop-order-offline/`;
export const paymentMethodsApiUrl = `${BASE_URL}/bazzar/payment-methods/`;
export const ordersCRUDUrl = `${BASE_URL}/bazzar/shop-order/`;
export const ordersPaymentCRUDUrl = `${BASE_URL}/bazzar/shop-order-payment/`;
export const shopOrderItemCRUDUrl = `${BASE_URL}/bazzar/shop-order-item/`;
export const b2bSalesApiUrl = `${BASE_URL}/dashboard/b2b-dashboard`;
export const b2cSalesApiUrl = `${BASE_URL}/dashboard/b2c-dashboard`;
export const combinedSalesApiUrl = `${BASE_URL}/dashboard/combined-orders-dashboard`;
export const getUsersListUrl = `${BASE_URL}/dashboard/user-list/`;
export const userFarmingCommodityApi = `${BASE_URL}/app/user-farming-commodity?user_id=`;
export const userExpanseDataApi = `${BASE_URL}/data/user-expense/`;
export const userExpanseDetailApi = `${BASE_URL}/app/expence-detail?expense_id=`;
export const userExpanseAnalyticsApi = `${BASE_URL}/app/expense-analytics?expense_id=`;
export const commodityMasterApi = `${BASE_URL}/app/user-commodity-master`;
export const combinedDropDownUserFarmingApi = `${BASE_URL}/app/combined-dropdown-user-farming?user_id=`;
export const userFarmingCommodityDataApi = `${BASE_URL}/data/user-farming-commodities/`;
export const dashboardUserApi = `${BASE_URL}/dashboard/dashboard-user/`;
export const userPointsApi = `${BASE_URL}/bazzar/shop-order-reward-points-history-user/?user_id=`;
export const userPointsHistoryApi = `${BASE_URL}/bazzar/shop-order-reward-points-history/`;
// APIs for user details
// `${dashboardUserApi}/$userId/points`
// `${dashboardUserApi}/$userId/history`
// `${dashboardUserApi}/$userId/expense`
// `${dashboardUserApi}/$userId/device`
// `${dashboardUserApi}/$userId/farms`
// `${dashboardUserApi}/$userId/satfarms`
// `${dashboardUserApi}/$userId/forum-post`

export const userDevicesListGetApi = `${BASE_URL}/dashboard/user-devices-list`;
export const userDevicesStatsGetApi = `${BASE_URL}/dashboard/device-stats`;
export const userDevicesDetailsGetApi = `${BASE_URL}/app/fetch-gsm-iot-data/`;
// export const userDevicesStatsGetApi = `${BASE_URL}/app/fetch-gsm-iot-data/<str:device_id>/`;
export const userWSDevicesDetailsGetApi = `${Pre_Prod_BASE_URL}/datalogger/weather-station-data/?device_id=`;

// export const getNotificationsUrl = `${BASE_URL}/data/notification/`;
export const getNotificationsUrl = `${BASE_URL}/data/notification-send-list`;
export const postNotificationUrl = `${BASE_URL}/data/send-notification/`;
export const shopOrderLogisticUrl = `${BASE_URL}/bazzar/shop-order-logistic/`;
export const shopOrderLogisticTrackingDashboardUrl = `${BASE_URL}/dashboard/shop-order-logistic-tracking-dashboard`;
export const manufacturerListGetUrl = `${BASE_URL}/dashboard/manufacturer-list/`;
export const manufacturerListCRUDUrl = `${BASE_URL}/bazzar/manufacturers/`;
export const shopListGetUrl = `${BASE_URL}/dashboard/shop-list/`;
export const shopCRUDUrl = `${BASE_URL}/bazzar/shops/`;
export const shopAddUrl = `${BASE_URL}/dashboard/shop-custom-add/`;
export const domainsListUrl = `${BASE_URL}/dashboard/domain-list/`;
export const categoryListUrl = `${BASE_URL}/dashboard/category-list/`;
export const domainsCRUDUrl = `${BASE_URL}/bazzar/domain/`;
export const categoriesCRUDUrl = `${BASE_URL}/bazzar/categories/`;
export const subcategoriesCRUDUrl = `${BASE_URL}/bazzar/subcategories/`;
export const shipmentsGetApiUrl = `${BASE_URL}/dashboard/shop-order-logistics`;
export const bazzarSearchOrderApiUrl = `${BASE_URL}/dashboard/bazzar-order-search?search=`;
export const orderPaymentGetApiUrl = `${BASE_URL}/dashboard/shop-order-payment`;
export const paymentStatsApiUrl = `${BASE_URL}/dashboard/bazzar-completed-payments-stats`;
export const websiteEnquiriesApiUrl = `${BASE_URL}/website/enquiry`;
export const fpoEnquiriesApiUrl = `${BASE_URL}/dashboard/fpo-enquiry-list`;
export const fpoEnquiriesCRUDApiUrl = `${BASE_URL}/data/fpoenquiry/`;
export const cbboFpoSummaryApiUrl = `${BASE_URL}/dashboard/cbbo-fpo-summary`;
export const oldShopEnquiriesApiUrl = `${BASE_URL}/dashboard/old-shop-enquiry-list`;
export const shopBulkOrderEnquiryViewApiUrl = `${BASE_URL}/bazzar/shop-bulk-order-enquiry-view`;
export const shopBulkOrderEnquiryPatchViewApiUrl = `${BASE_URL}/bazzar/shop-dukaan-bulkorder-enquiry/`;
export const productListingApiUrl = `${BASE_URL}/dashboard/shop-product-list`;
export const productStatsApiUrl = `${BASE_URL}/dashboard/product-stats`;
export const getProductDetailsApiUrl = `${BASE_URL}/dashboard/product-details/`;
export const categoryCRUDUrl = `${BASE_URL}/bazzar/categories/`;
export const communityCRUDUrl = `${BASE_URL}/community/post/`;
export const forumGetApi = `${BASE_URL}/community/forum-home-view/`;
export const forumCRUDApi = `${BASE_URL}/community/forum/`;
export const forumCommentsGetApi =
    `${BASE_URL}/community/forum-comment-by-forum-id?forum_id=`;
export const forumCommentsPostApi =
    `${BASE_URL}/community/forum-comment/`;
export const satelliteAnalyticsViewApi = `${BASE_URL}/dashboard/satellite-data-analytics`;
export const satelliteTableViewApi = `${BASE_URL}/dashboard/dashboard-satellite`;
export const satelliteTableViewEnquiryApi = `${BASE_URL}/dashboard/dashboard-satellite-enquiry`;
export const satelliteTableViewEnquiryStatsApi = `${BASE_URL}/dashboard/dashboard-satellite-enquiry-stats`;
export const farmSatelliteSubscriptionApi = `${BASE_URL}/data/farm-satellite-subscription/`;
export const userFarmDataApi = `${BASE_URL}/data/user-farms/`;
export const dashboardHomeApi = `${BASE_URL}/dashboard/dashboard-home`;
export const hrAdminDashboardApi = `${BASE_URL}/dashboard/hr-admin-dashboard/`;
export const dashboardStatsApi = `${BASE_URL}/dashboard/dashboard-stats`;
export const staffDashboardStatsApi = `${BASE_URL}/dashboard/staff-dashboard-stats`;
export const staffClockInApi = `${BASE_URL}/dashboard/staff-clock-in/`;
export const staffClockOutApi = `${BASE_URL}/dashboard/staff-clock-out/`;
export const salespersonMonthlySalesStatsApi = `${BASE_URL}/lead-manager/salesperson-monthly-sales-stats?user_id=`;
export const dashboardProductStatsApi = `${BASE_URL}/dashboard/dashboard-product-stats`;
export const dashboardMapStatsApi = `${BASE_URL}/dashboard/dashboard-map-stats`;
export const dashboardMarketingBannerApi = `${BASE_URL}/dashboard/dashboard-marketing-banner`;
export const marketingBannerCRUDApi = `${BASE_URL}/bazzar/shop-carousel/`;
export const mobilePopupCRUDApi = `${BASE_URL}/data/mobile-popup-crud/`;
export const notificationTemplateGet = `${BASE_URL}/data/notification-template/grouped/`;
export const notificationTemplateCRUDApi = `${BASE_URL}/data/notification-template/`;
export const notificationTemplateHistoryApi = `${BASE_URL}/data/notification-template-history`;
export const notificationTemplateScheduleApi = `${BASE_URL}/data/schedule-notification-campaign/`;
export const getCbboApi = `${BASE_URL}/dashboard/cbbo`;
export const userSegerationApi = `${BASE_URL}/data/user-segeration/`;
export const userOrganizationApi = `${BASE_URL}/data/userorganization/`;
export const getFpoApi = `${BASE_URL}/dashboard/fpo`;
export const userFpoListApi = `${BASE_URL}/dashboard/user-fpo-list`;
export const cbboCRUDApiUrl = `${BASE_URL}/data/cbbo/`;
export const fpoCRUDApiUrl = `${BASE_URL}/data/fpo/`;

// CSC Dropdown APIs
export const stateApi = `${BASE_URL}/app/state-dropdown`;
export const districtApi = `${BASE_URL}/app/districts/`;
// Ex: export const districtApi = `${BASE_URL}/app/districts/<state name>`;

// end point for scripts
export const mandiRateUpdateApi = `${BASE_URL}/cronjobs/mandi-rate-update2/`;
export const sendSatelliteNotificationsApi = `${BASE_URL}/cronjobs/send-satellite-notification/`;
export const sendUserExpenseNotificationsApi = `${BASE_URL}/cronjobs/send-user-expense-notification/`;
export const getScriptLogsApi = `${BASE_URL}/cronjobs/cronjobslogs`;
export const sendSatelliteReportApi = `${BASE_URL}/cronjobs/send-satellite-report/`;
export const sendSatelliteReportSpecificApi = `${BASE_URL}/cronjobs/send-satellite-report-specific/`;

// Lead API
export const leadListGetApiApi = `${BASE_URL}/lead-manager/leads-list/`;
export const leadListGetAdminApi = `${BASE_URL}/lead-manager/leads-admin/`;
export const downloadLeadsUrlApi = `${BASE_URL}/lead-manager/download-csv/?template=true`;
export const uploadLeadsApi = `${BASE_URL}/lead-manager/upload-csv/`;
export const leadsCRUDApi = `${BASE_URL}/lead-manager/leads/`;
export const followupCRUDApi = `${BASE_URL}/lead-manager/followups/`;
export const calllogsCRUDApi = `${BASE_URL}/lead-manager/calllogs/`;
export const currentLeadViewApi = `${BASE_URL}/lead-manager/current-lead-view`;
export const assignTelecallingLeadsApi = `${BASE_URL}/lead-manager/assign-telecalling-followup/`;
export const leadStatsCombinedApi = `${BASE_URL}/lead-manager/lead-stats-combined/`;
export const leadStatsApi = `${BASE_URL}/lead-manager/lead-stats`;
export const b2cSalesPersonDashboardApi = `${BASE_URL}/lead-manager/b2c-salesperson-dashboard`;
export const b2cInterestedLeadsApi = `${BASE_URL}/lead-manager/b2c-interested-leads`;
export const b2cDashboardUpdateApi = `${BASE_URL}/lead-manager/b2c-salesperson-dashboard-update/`;
export const b2cLeadPhoneStatsApi = `${BASE_URL}/lead-manager/b2c-lead-phone-stats?user_id=`;
export const b2cLeadDetailApi = `${BASE_URL}/lead-manager/b2c-lead-detail/`;
export const b2cAdminLeadDashboardApi = `${BASE_URL}/lead-manager/admin-b2c-lead-dashboard/`;
export const b2cLeadApi = `${BASE_URL}/lead-manager/b2c-leads/`;
export const b2cSalespersonDailyCallStatsApi = `${BASE_URL}/lead-manager/b2c-salesperson-daily-call-stats/`;
export const b2cExcelUploadAndAssignApi = `${BASE_URL}/lead-manager/b2c-excel-upload-and-assign/`;
export const b2cExcelDownloadAndAssignApi = `${BASE_URL}/lead-manager/b2c-salesperson-dashboard-excel-export/`;
export const b2cAddSingleLeadApi = `${BASE_URL}/lead-manager/b2c-add-single-lead/`;
export const b2cNpcLeadsSheetDownloadApi = `${BASE_URL}/lead-manager/b2c-npc-leads-sheet-download/`;

// B2B Lead Manager APIs
export const b2bCampaignsViewApi = `${BASE_URL}/lead-manager/b2c-campaigns-list`;
export const b2bCampaignsCRUDApi = `${BASE_URL}/lead-manager/b2b-campaigns/`;
export const b2bLeadsCRUDApi = `${BASE_URL}/lead-manager/b2b-leads/`;
export const b2bLeadNotesCRUDApi = `${BASE_URL}/lead-manager/b2b-lead-notes/`;
export const b2bLeadUploadApi = `${BASE_URL}/lead-manager/b2b-lead-upload/`;
export const b2bLeadsCampaignFolderApi = `${BASE_URL}/lead-manager/b2b-leads-campaign-folder/`;
export const b2bLeadsDistrictFolderApi = `${BASE_URL}/lead-manager/b2b-leads-district-folder/`;
export const b2bLeadsViewApi = `${BASE_URL}/lead-manager/b2b-leads-view/`;
export const b2bBulkLeadAssignApi = `${BASE_URL}/lead-manager/b2b-bulk-lead-assign/`;
export const b2bSalespersonDashboardApi = `${BASE_URL}/lead-manager/b2b-salesperson-dashboard`;
export const b2bMyDealersApi = `${BASE_URL}/lead-manager/b2b-my-dealers`;
export const paidB2BDealersApi = `${BASE_URL}/dashboard/paid-b2b-dealers/`;
export const b2bLogInteractionApi = `${BASE_URL}/lead-manager/b2b-log-interaction/`;
export const b2bLeadWorkflowDetailApi = `${BASE_URL}/lead-manager/b2b-lead-detail/`;
export const b2bLeadAssignmentsApi = `${BASE_URL}/lead-manager/b2b-lead-assignments/`;
export const b2bLeadInteractionsApi = `${BASE_URL}/lead-manager/b2b-lead-interactions/`;
export const b2bLeadFollowupsApi = `${BASE_URL}/lead-manager/b2b-lead-followups/`;
export const b2bSalespersonListApi = `${BASE_URL}/lead-manager/b2b-salesperson-list`;
export const b2bQuickAddLeadApi = `${BASE_URL}/lead-manager/b2b-quick-add-lead/`;

// Support ticker
export const supportTicketDashboardApi = `${BASE_URL}/dashboard/support-dashboard`;
export const supportTicketTimelineGetApi = `${BASE_URL}/dashboard/ticket-timeline?ticket_id=`;
export const supportTicketCRUDApi = `${BASE_URL}/support/tickets/`;
export const supportTicketTimelineCRUDApi = `${BASE_URL}/support/ticket-timeline/`;
export const staffUsersSearchApi = `${BASE_URL}/dashboard/staff-users-search`;
export const supportTicketAssignableUsersApi = `${BASE_URL}/dashboard/search-user-by-role/`;
export const supportTicketUserConfirmedOrdersApi = `${BASE_URL}/dashboard/user-confirmed-orders/`;
export const dashboardTicketCreateApi = `${BASE_URL}/dashboard/tickets/create/`;
export const dashboardTicketEditApi = `${BASE_URL}/dashboard/tickets/`;

// Inventory APIs
export const rawMaterialInventoryCRUDApi = `${BASE_URL}/inventory/raw-material/`;
export const rawMaterialInventoryViewApi = `${BASE_URL}/inventory/raw-material-view`;
export const rawMaterialInventoryDetailedViewApi = `${BASE_URL}/inventory/raw-material-transaction-view?raw_material_id=`;
export const rawMaterialInventoryCRUDTransactionApi = `${BASE_URL}/inventory/raw-material-transaction/`;
export const kitInventoryCreateApi = `${BASE_URL}/inventory/kit-inventory-component-create/`;
export const kitInventoryViewApi = `${BASE_URL}/inventory/kit-view`;
export const kitAssemblyViewApi = `${BASE_URL}/inventory/kit-assembly-view`;
export const rawInventoryDropdownApi = `${BASE_URL}/inventory/raw-inventory-dropdown`;
export const kitAssemblyCRUDApi = `${BASE_URL}/inventory/kit-assembly/`;
export const kitInventoryCRUDApi = `${BASE_URL}/inventory/kit/`;
export const kitDropdownApi = `${BASE_URL}/inventory/kit-dropdown`;
export const productsInventoryApi = `${BASE_URL}/dashboard/products-inventory`;

export const chatbotApiUrl = `${Pre_Prod_BASE_URL}/chatbot`;

// AI Analytics APIs
export const aiAnalyticsUrl = `${Pre_Prod_BASE_URL}/chatbot/chatbot-analytics`;

// AI chats history
export const aiUserInboxUrl = `${Pre_Prod_BASE_URL}/chatbot/user-inbox/`;
export const aiUserMessageHistoryUrl = `${Pre_Prod_BASE_URL}/chatbot/user-message-history/`;
// Ex: aiUserMessageHistoryUrl/<user_id>
export const aiChatbotHistoryUrl = `${Pre_Prod_BASE_URL}/chatbot/chatbot-history/`;

// Blog APIs
export const blogCategoryCRUDApi = `${BASE_URL}/website/blog-category/`;
export const blogTagCRUDApi = `${BASE_URL}/website/blog-tag/`;
export const blogPostCRUDApi = `${BASE_URL}/website/blog-post/`;
export const blogSocialMediaCRUDApi = `${BASE_URL}/website/blog-social-media/`;
export const blogDetailApi = `${BASE_URL}/website/blog-post-detail`;

// Download APIs
export const b2cClientDataDownloadApi = `${BASE_URL}/dashboard/b2c-client-data-download/`;
export const b2bClientDataDownloadApi = `${BASE_URL}/dashboard/b2b-client-data-download/`;
export const productVisitorDataDownloadApi = `${BASE_URL}/dashboard/product-visitor-data-download/`;
export const leadDataDownloadApi = `${BASE_URL}/lead-manager/lead-data-download/`;
export const categorySalesDownloadApi = `${BASE_URL}/dashboard/category-state-district-sales-report/`;
export const salesSheetExportApi = `${BASE_URL}/dashboard/sales-new-sheet-export/`;

// Bigship APIs
export const userEmail = "rashailagro@gmail.com";
export const userPassword = "#Fasalam@2025";
export const accessToken = "906a57513303cf2b54d0bcde6a354f41c5dee88b0c8fe5ee33273b82293765ef";
export const BIG_SHIP_BASE_URL = "https://api.bigship.in/";
export const apiEndPoint = `${BIG_SHIP_BASE_URL}api/login/user`;
export const getWalletBalancePoint = `${BIG_SHIP_BASE_URL}api/Wallet/balance/get`;
export const getLocationSalesApi = `${BASE_URL}/bazzar/district-sales?location=`;

export const shopOrderReturnCancellationUrl = `${BASE_URL}/bazzar/shop-order-return-cancellation-log/`;

export const salesDashboardApiUrl = `${BASE_URL}/dashboard/shop-order-sales-dashboard`;
export const productSalesApiUrl = `${BASE_URL}/dashboard/product-sales`;
export const b2bLedgerApiUrl = `${BASE_URL}/dashboard/b2b-ledger`;
export const b2cLedgerApiUrl = `${BASE_URL}/dashboard/b2c-ledger`;

// Label & Invoice APIs
export const orderLabelApiUrl = `${BASE_URL}/dashboard/order-label/`;
export const proformaInvoiceApiUrl = `${BASE_URL}/dashboard/proforma-invoice/`;
export const proformaConvertToOrderApiUrl = `${BASE_URL}/dashboard/proforma-invoice/convert-to-order/`;
export const inPackingOrdersApiUrl = `${BASE_URL}/dashboard/shop-order-in-packing`;
export const orderInvoiceLabelApiUrl = `${BASE_URL}/dashboard/order-invoice-label/`;
export const b2bPackagingOrdersApiUrl = `${BASE_URL}/dashboard/b2b-packaging-orders/`;
export const b2bOrderLabelApiUrl = `${BASE_URL}/dashboard/b2b-order-label/`;
export const indianPostTrackApiUrl = `${BASE_URL}/dashboard/indian-post/track/`;


// Extended Server APIs
export const EXTENDED_BASE_URL = isProd ? "https://extended.rashailagro.in/" : "http://127.0.0.1:8001/";
export const extendedServerToken = "21d659bc6a9022073167caf814e90ef8c8563d9a";
export const gsmIotDeviceList = `${EXTENDED_BASE_URL}gsm-iot/gsm-list/`;
export const gsmIotDeviceDetail = `${EXTENDED_BASE_URL}gsm-iot/gsm-details/`;
export const gsmIotDeviceSubscriptionHistory = `${EXTENDED_BASE_URL}gsm-iot/device-subscription-history/`;
